import { TriangleDownIcon } from "@chakra-ui/icons";
import { Flex, Text } from "@chakra-ui/react";
import { Spot, SpotType } from "~/generated/graphql.types";
import { SpotParamsFragment } from "~/routes/_shared/fragments.generated";

const spotCategoryToBgColor = (spotType: SpotType) => {
  switch (spotType) {
    case SpotType.RoutingGuide:
      return "gray.800";
    case SpotType.OptionalWaypoint:
      return "green.900";
    case SpotType.SubaruMoment:
      return "blue.600";
    case SpotType.Narration:
      return "yellow.600";

    default:
      return "orange.800";
  }
};

const spotCategoryToBorderColor = (category: string) => {
  switch (category) {
    case SpotType.RoutingGuide:
      return "gray.600";
    case SpotType.OptionalWaypoint:
      return "green.300";
    case SpotType.SubaruMoment:
      return "blue.300";
    case SpotType.Narration:
      return "yellow.300";
    default:
      return "#ff4500";
  }
};

export const SpotOrderBadge = ({
  label,
  spot,
  pointer = false,
  isSelected = false,
}: {
  label: string;
  spot: Spot | SpotParamsFragment;
  pointer?: boolean;
  isSelected?: boolean;
}) => {
  // 選択時に大きくする
  const sizeCoeff = isSelected ? 1.5 : 1;
  return (
    <Flex
      w={
        spot.spotType === SpotType.RoutingGuide ? 4 * sizeCoeff : 8 * sizeCoeff
      }
      h={
        spot.spotType === SpotType.RoutingGuide ? 4 * sizeCoeff : 8 * sizeCoeff
      }
      alignItems="center"
      justifyContent="center"
      rounded="full"
      borderWidth={3 * sizeCoeff}
      bgColor={spotCategoryToBgColor(spot.spotType)}
      borderColor={spotCategoryToBorderColor(spot.spotType)}
    >
      <Text
        fontWeight={600}
        lineHeight={6}
        color={undefined}
        fontSize={isSelected ? "lg" : "sm"}
      >
        {spot.spotType === SpotType.RoutingGuide ? null : label}
      </Text>
      {pointer && (
        <TriangleDownIcon
          position="absolute"
          zIndex={-1}
          bottom={spot.spotType === SpotType.RoutingGuide ? -1.5 : -4}
          color={spotCategoryToBorderColor(spot.spotType)}
          fontSize={spot.spotType === SpotType.RoutingGuide ? 10 : 32}
        />
      )}
    </Flex>
  );
};
